module.exports = __webpack_public_path__ + "img/home-3.29d1c4c9.webp";